module.exports = __webpack_public_path__ + "img/daimuzhi.8086ca61.jpg";